var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.152588C4.44183 0.152588 4.8 0.51076 4.8 0.952588V3.35259H7.2C7.64183 3.35259 8 3.71076 8 4.15259C8 4.59442 7.64183 4.95259 7.2 4.95259H4.8V7.35259C4.8 7.79442 4.44183 8.15259 4 8.15259C3.55817 8.15259 3.2 7.79442 3.2 7.35259V4.95259H0.8C0.358172 4.95259 0 4.59442 0 4.15259C0 3.71076 0.358172 3.35259 0.8 3.35259H3.2V0.952588C3.2 0.51076 3.55817 0.152588 4 0.152588Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusWhite);
export default __webpack_public_path__ + "static/media/plus-white.e81421d51ae976acd92a70901078288e.svg";
export { ForwardRef as ReactComponent };